import { render, staticRenderFns } from "./merchant-services.vue?vue&type=template&id=4e3066ab&scoped=true&lang=pug&"
import script from "./merchant-services.vue?vue&type=script&lang=js&"
export * from "./merchant-services.vue?vue&type=script&lang=js&"
import style0 from "./merchant-services.vue?vue&type=style&index=0&id=4e3066ab&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3066ab",
  null
  
)

export default component.exports